"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _request = _interopRequireDefault(require("../../request"));
// kpi 设置
// 总量SOP
var _default = exports.default = {
  getKpiList: function getKpiList(url, data, cancelToken, module) {
    return (0, _request.default)({
      module: module || '',
      url: url,
      method: 'post',
      data: data,
      cancelToken: cancelToken
    });
  },
  importKpiFile: function importKpiFile(url, data, module) {
    return (0, _request.default)({
      module: module || '',
      url: url,
      method: 'post',
      data: data
    });
  },
  exportKpiFile: function exportKpiFile(url, data, module) {
    return (0, _request.default)({
      module: module || '',
      url: url,
      method: 'post',
      data: data,
      responseType: 'blob'
    });
  },
  exportErrorFileResult: function exportErrorFileResult(id, module) {
    return (0, _request.default)({
      module: module || '',
      url: "/protected/excelDetail/export/error/".concat(id),
      method: 'post',
      data: {
        id: id
      },
      responseType: 'blob'
    });
  }
};